import { render, staticRenderFns } from "./IconUploadImage.vue?vue&type=template&id=3b664437&scoped=true&"
import script from "./IconUploadImage.vue?vue&type=script&lang=js&"
export * from "./IconUploadImage.vue?vue&type=script&lang=js&"
import style0 from "./IconUploadImage.vue?vue&type=style&index=0&id=3b664437&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b664437",
  null
  
)

export default component.exports